import * as routesConfig from '../server/pathConfig.js';

export const baseURL = 'http://engine.jupiter.internal.tech/api/jupiter';
export const middlewarePrefix = routesConfig.routePrefix;
